<form
  class="container-grid"
  autocomplete="on"
  [formGroup]="rule238Form"
  (ngSubmit)="saveRule238()"
>

  <!-- No. PAMA -->
  <div class="grid-first">
    <label for="pama" class="form-label">
      No. PAMA
    </label>
    <input
      type="text"
      id="pama"
      class="form-control"
      formControlName="pama_number"
      maxlength="150"
    >
  </div>

  <!-- Folio fiscal CFDI -->
  <h2 class="sub-title grid-span4">
    Datos de facturación
  </h2>
  <div class="grid-first">
    <label for="folioFiscal" class="form-label">
      Folio fiscal CFDI
    </label>
    <input
      type="text"
      id="folioFiscal"
      class="form-control"
      formControlName="fiscal_folio_cfdi"
      maxlength="150"
    >
  </div>

  <!-- Monto total del CFDI -->
  <div>
    <label for="montoCFDI" class="form-label">
      Monto total del CFDI
    </label>
    <input
      type="text"
      id="montoCFDI"
      class="form-control"
      formControlName="total_amount_cfdi"
      maxlength="150"
    >
  </div>

  <!-- Monto total obtenido por la prestación del servicio para el manejo, almacenaje y custodia de las mercancías -->
  <div class="grid-first-span2">
    <label for="montoPresentacion" class="form-label">
      Monto total obtenido por la prestación del servicio para el manejo, almacenaje y custodia de las mercancías
    </label>
    <input
      type="text"
      id="montoPresentacion"
      class="form-control"
      formControlName="total_amount_presentation"
      maxlength="150"
    >
  </div>

  <!-- Cantidad de mercancía que se encuentra en depósito de conformidad a la unidad de medida con la que se factura el servicio prestado -->
  <div class="grid-first-span2">
    <label for="cantidadMercancia" class="form-label">
      Cantidad de mercancía que se encuentra en depósito de conformidad a la unidad de medida con la que se factura el servicio prestado
    </label>
    <input
      type="text"
      id="cantidadMercancia"
      class="form-control"
      formControlName="amount_merchandise_deposit"
      maxlength="150"
    >
  </div>

  <!-- Monto correspondiente a compensación de moneda nacional -->
  <div class="grid-first-span2">
    <label for="montoMonedaNacional" class="form-label">
      Monto correspondiente a compensación de moneda nacional
    </label>
    <input
      type="text"
      id="montoMonedaNacional"
      class="form-control"
      formControlName="compensation_amount"
      maxlength="150"
    >
  </div>
  <h2 class="sub-title grid-span4">
    Información adicional
  </h2>
  <div class="grid-1-3">
    <label for="registroViolacionDañoExtravio" class="form-label">
      Registro de violación de daño o extravió de bultos/mercancías
    </label>
    <input
      type="text"
      id="registroViolacionDañoExtravio"
      class="form-control"
      formControlName="damage_violation_record"
      maxlength="50"
    />
  </div>
  <div class="grid-span4" formArrayName="customs_embargoed_merchandise">
    <p class="form-label">
      Mercancía que fue embargada por autoridades aduaneras
    </p>
    <div
      class="mercanciaEmbargadaAduanaContainer"
      *ngFor="
        let mercancia of customs_embargoed_merchandiseArr['controls'];
        let i = index
      "
      [formGroupName]="i"
    >
      <div>
        <input
          type="text"
          class="form-control"
          name="mercanciaEmbargadaOficio"
          placeholder="Número de oficio"
          formControlName="trade_number"
          appBlockLetters
        />
        <span
          class="form-text text-danger"
          *ngIf="
            isValidFieldInArray('customs_embargoed_merchandise', i, 'trade_number')
          "
        >
          Ingresa el número de oficio válido
        </span>
      </div>
      <div>
        <input
          type="datetime-local"
          class="form-control"
          name="mercanciaEmbargadaFecha"
          formControlName="office_date"
        />
        <span
          class="form-text text-danger"
          *ngIf="
            isValidFieldInArray('customs_embargoed_merchandise', i, 'office_date')
          "
        >
          Ingresa la fecha
        </span>
      </div>
      <div>
        <input
          type="number"
          class="form-control"
          name="mercanciaEmbargadaPeso"
          placeholder="Peso de la mercancía embargada"
          formControlName="weight_embargoed_merchandise"
        />
        <span
          class="form-text text-danger"
          *ngIf="
            isValidFieldInArray(
              'customs_embargoed_merchandise',
              i,
              'weight_embargoed_merchandise'
            )
          "
        >
          Ingresa el peso valido
        </span>
      </div>
      <div>
        <input
          type="file"
          accept=".pdf"
          class="form-control"
          name="mercanciaEmbargadaArchivo"
          (change)="fileInput($event, i, 'customs_embargoed_merchandise')"
          *ngIf="!filesUrl[i]"
        />
        <a
          *ngIf="filesUrl[i]"
          [href]="filesUrl[i]"
          target="_blank"
          class="form-control fileUrl"
          >Descargar Archivo</a
        >
        <span
          class="form-text text-danger"
          *ngIf="isValidFieldInArray('customs_embargoed_merchandise', i, 'file')"
        >
          {{ errorMessageFile }}
        </span>
      </div>
    </div>
  </div>
  <button
    type="button"
    class="btn-lote btn-registro grid-first"
    (click)="addFormGroup(true)"
  >
    Agregar registro
  </button>
  <button
    type="button"
    class="btn-lote btn-registro"
    (click)="removeFormGroup('mercancia')"
    *ngIf="customs_embargoed_merchandiseArr.length"
  >
    Eliminar registro
  </button>
  <div class="grid-1-3">
    <label for="mercanciaAlmacenadaAutoridad" class="form-label">
      Identificación de mercancía almacenada a solicitud de la autoridad
    </label>
    <input
      type="text"
      id="mercanciaAlmacenadaAutoridad"
      class="form-control"
      formControlName="identification_stored_merchandise"
      maxlength="100"
    />
  </div>
  <div class="grid-1-3">
    <label for="volumenMercanciaRecinto" class="form-label">
      Volumen que ocupa la mercancía en el recinto fiscalizado
    </label>
    <input
      type="text"
      id="volumenMercanciaRecinto"
      class="form-control"
      formControlName="volume_occupied_merchandise"
      appBlockLetters
    />
    <span
      class="form-text text-danger"
      *ngIf="isValidField('volume_occupied_merchandise')"
    >
      Ingresa un número válido con máximo dos decimales
    </span>
  </div>

  <!-- Dimensión del contenedor -->
  <div class="grid-first">
    <label for="dimensionContenedor" class="form-label">
      Dimensión del contenedor
    </label>
    <input
      type="text"
      id="dimensionContenedor"
      class="form-control"
      formControlName="container_dimension"
      maxlength="150"
    >
  </div>

  <!-- Tipo de contenedor -->
  <div>
    <label for="tipoContenedor" class="form-label">
      Tipo de contenedor
    </label>
    <input
      type="text"
      id="tipoContenedor"
      class="form-control"
      formControlName="container_type"
      maxlength="150"
    >
  </div>

  <!-- Número de sellos del contenedor -->
  <div>
    <label for="numeroSellosContenedor" class="form-label">
      Número de sellos del contenedor
    </label>
    <input
      type="text"
      id="numeroSellosContenedor"
      class="form-control"
      formControlName="number_container_seals"
      maxlength="150"
    >
  </div>

  <!-- No. de candados del contenedor -->
  <div class="grid-first">
    <label for="candadosContenedor" class="form-label">
      No. de candados del contenedor
    </label>
    <input
      type="text"
      id="candadosContenedor"
      class="form-control"
      formControlName="number_container_locks"
      maxlength="150"
    >
  </div>

  <!-- Contenedor desconsolidado -->
  <div class="grid-first">
    <label for="contenedorDesconsolidado" class="form-label">
      Contenedor desconsolidado
    </label>
    <input
      type="text"
      id="contenedorDesconsolidado"
      class="form-control"
      formControlName="unconsolidated_container"
      maxlength="150"
    >
  </div>

  <!-- Almacén desconsolidado -->
  <div>
    <label for="almacenDesconsolidado" class="form-label">
      Almacén desconsolidado
    </label>
    <input
      type="text"
      id="almacenDesconsolidado"
      class="form-control"
      formControlName="deconsolidated_store"
      maxlength="150"
    >
  </div>

  <!-- Medio de transporte desconsolidado -->
  <div>
    <label for="medioTransporteDesconsolidado" class="form-label">
      Medio de transporte desconsolidado
    </label>
    <input
      type="text"
      id="medioTransporteDesconsolidado"
      class="form-control"
      formControlName="unconsolidated_means_transport"
      maxlength="150"
    >
  </div>

  <!-- Contenedor consolidado -->
  <div class="grid-first">
    <label for="contenedorConsolidado" class="form-label">
      Contenedor consolidado
    </label>
    <input
      type="text"
      id="contenedorConsolidado"
      class="form-control"
      formControlName="consolidated_container"
      maxlength="150"
    >
  </div>

  <!-- Almacén consolidado -->
  <div>
    <label for="almacenConsolidado" class="form-label">
      Almacén consolidado
    </label>
    <input
      type="text"
      id="almacenConsolidado"
      class="form-control"
      formControlName="consolidated_store"
      maxlength="150"
    >
  </div>

  <!-- Medio de transporte consolidado -->
  <div>
    <label for="medioTransporteConsolidado" class="form-label">
      Medio de transporte consolidado
    </label>
    <input
      type="text"
      id="medioTransporteConsolidado"
      class="form-control"
      formControlName="consolidated_means_transport"
      maxlength="150"
    >
  </div>

  <!-- Botones -->
  <div class="grid-all">
    <button type="button" class="btn-lote me-5 btn-lote-responsive" (click)="goBackShipDetails()">
      Regresar
    </button>
    <button
      type="button"
      class="btn-lote bg-danger border-danger btn-hover text-light"
      *ngIf="canDelete"
      (click)="deleteRule238()"
    >
      <i class="bi bi-x-lg"></i>
      Eliminar
    </button>
    <button type="submit" class="btn-lote ms-5 btn-lote-responsive">Guardar</button>
  </div>

</form>
